import { LucideIcon } from 'lucide-react';

export interface Club {
  id: string;
  name: string;
  members: number;
  points: number;
  icon: string;
  status: 'elite' | 'premium';
}

export const clubs: Club[] = [
  {
    id: 'peak-performance',
    name: 'Beast Mode Brigade',
    members: 42,
    points: 3200,
    icon: 'Zap',
    status: 'elite'
  },
  {
    id: 'elite-performance',
    name: 'Savage Squad Elite',
    members: 35,
    points: 2800,
    icon: 'Crown',
    status: 'elite'
  },
  {
    id: 'power-squad',
    name: 'Gains Gladiators',
    members: 28,
    points: 2450,
    icon: 'Flame',
    status: 'premium'
  },
  {
    id: 'fitness-warriors',
    name: 'Flex Factory Fam',
    members: 31,
    points: 2100,
    icon: 'Shield',
    status: 'premium'
  }
];